// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.table {
  margin: auto;
  max-height: 15%;
  max-width: 15%;
}

.error-text {
  color: #61dafb;
  font-size: 0.9rem;
  margin-top: 4px;
}

.form-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

form {
    border-color: #61dafb;
    border-style: double;
    border-width: 2px; /* Corrected from 2cap to 2px */
    padding: 1rem;
}

p.calculation-details{
  border-color: #61dafb;
  border-style: double;
  border-width: 2px; /* Corrected from 2cap to 2px */
  padding: 1rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  max-width: 300px;
  margin: 0 auto;
}

.login-form input {
  padding: 10px;
  width: 100%;
  font-size: 1em;
}

.login-form button {
  padding: 10px 20px;
  font-size: 1em;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB,EAAE,+BAA+B;IAClD,aAAa;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB,EAAE,+BAA+B;EAClD,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.table {\n  margin: auto;\n  max-height: 15%;\n  max-width: 15%;\n}\n\n.error-text {\n  color: #61dafb;\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\n.form-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\nform {\n    border-color: #61dafb;\n    border-style: double;\n    border-width: 2px; /* Corrected from 2cap to 2px */\n    padding: 1rem;\n}\n\np.calculation-details{\n  border-color: #61dafb;\n  border-style: double;\n  border-width: 2px; /* Corrected from 2cap to 2px */\n  padding: 1rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.login-form input {\n  padding: 10px;\n  width: 100%;\n  font-size: 1em;\n}\n\n.login-form button {\n  padding: 10px 20px;\n  font-size: 1em;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
